import { TRole } from '../pages/auth/interfaces';
import { menuConfigItems } from '../constants/menuConfigItems';

const {
  profile,
  usersManager,
  users,
  legal,
  settings,
  adminChats,
} = menuConfigItems;

const getDefaultMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [profile],
  },
});

const getManagerMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [usersManager, adminChats, profile],
  },
});

const getAdminMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [users, settings, legal, adminChats],
  },
});

const getGuestMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [],
  },
});

const getMenuConfig = (userRoles: TRole[], isAuthorized?: boolean) => {
  if (isAuthorized) {
    if (userRoles && userRoles.includes('ROLE_ADMIN')) {
      return getAdminMenu();
    }
    if (userRoles && userRoles.includes('ROLE_MANAGER')) {
      return getManagerMenu();
    }
    return getDefaultMenu();
  }
  return getGuestMenu();
};

export default getMenuConfig;
